/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Strap_MaterialInputs */

const en_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strap Material`)
};

const es_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material de la correa`)
};

const fr_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matière du bracelet`)
};

const de_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Armbandmaterial`)
};

const ja_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ストラップ素材`)
};

const zh_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表带材质`)
};

const ar_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مادة السوار`)
};

const id_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material Tali`)
};

const it_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Materiale Cinturino`)
};

const ru_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Материал ремешка`)
};

const pt_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Material da Pulseira`)
};

const ko_field_strap_material = /** @type {(inputs: Field_Strap_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스트랩 소재`)
};

/**
* | output |
* | --- |
* | "Strap Material" |
*
* @param {Field_Strap_MaterialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_strap_material = /** @type {((inputs?: Field_Strap_MaterialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Strap_MaterialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_strap_material(inputs)
	if (locale === "es") return es_field_strap_material(inputs)
	if (locale === "fr") return fr_field_strap_material(inputs)
	if (locale === "de") return de_field_strap_material(inputs)
	if (locale === "ja") return ja_field_strap_material(inputs)
	if (locale === "zh") return zh_field_strap_material(inputs)
	if (locale === "ar") return ar_field_strap_material(inputs)
	if (locale === "id") return id_field_strap_material(inputs)
	if (locale === "it") return it_field_strap_material(inputs)
	if (locale === "ru") return ru_field_strap_material(inputs)
	if (locale === "pt") return pt_field_strap_material(inputs)
	return ko_field_strap_material(inputs)
});